import { ContentCatalogFolderSerializer } from "@models/serializers/folderSerializer";
import { httpRequest } from "../../http";
import { ContentCatalogFolder } from "@models/contentCatalogFolder.model";

export class CommandGetContentCatalogFolders {
  async run(
    organizationId: number,
    parentId?: number,
    withAds?: boolean,
    type?: string,
    signal?: AbortSignal,
  ) {
    let url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/${organizationId}/folders/`;

    const params: any = {};
    if (parentId !== undefined) params.parent_id = parentId;
    if (withAds) params.with_ads = withAds;
    if (type) params.type = type;

    url += `?${new URLSearchParams(params).toString()}`;

    try {
      const response = await httpRequest<any>(url, { method: "GET", signal });
      return this.deserialize(response);
    } catch (error) {
      if (signal?.aborted) throw error;
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): ContentCatalogFolder[] {
    return new ContentCatalogFolderSerializer().deserializeList(data);
  }
}
